<script setup>
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="text">
    <div class="gap-3 flex flex-col">
      <div
        v-for="article in contentAttributes.items"
        :key="article.id"
        class="message-text__wrap"
      >
        <div class="text-content">
          <a
            :href="article.link"
            class="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ article.title }}
          </a>
          {{ article.description }}
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
